import { ExEmptyState, ExIcon } from '@boomi/exosphere';
import type { DebugTabId } from '../../../../../types/debugger';
import { useDebugState } from '../../DebugProvider';
import RootFaultsAccordion from './RootFaultsAccordion';

const RootFaults = (_: { screen?: DebugTabId }) => {
    const { callStack: callStackItems } = useDebugState();

    const selectedCallStackItem = callStackItems.length
        ? callStackItems.find((callStackItem) => callStackItem.isSelected)
        : null;

    const rootFaults = selectedCallStackItem ? selectedCallStackItem.rootFaults : null;

    return (
        <div data-testid="root-faults" className="full-height flex align-center call-stack-outer">
            {rootFaults ? (
                <div className="debug-tabs-inner padding">
                    <RootFaultsAccordion rootFaults={rootFaults} />
                </div>
            ) : (
                <div className="center">
                    <ExEmptyState
                        label="There are no root faults to display"
                        text="Everything seems fine."
                    >
                        <ExIcon icon="Error" slot="header" />
                    </ExEmptyState>
                </div>
            )}
        </div>
    );
};

export default RootFaults;
